import * as React from 'react';
import { cn } from '../../lib/utils';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  mono?: boolean;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, mono, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-lg bg-surface px-3 py-2 text-sm text-ink hairline outline-none transition focus:shadow-[inset_0_0_0_2px_var(--color-accent)] placeholder:text-faint disabled:cursor-not-allowed disabled:opacity-50',
          mono && 'font-mono text-xs',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export { Input };
